import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, BoxIcon } from "lucide-react";
import { useBrand } from "../../hooks/useBrand";
import { useDarkClasses } from "../../hooks/useDarkClasses";
import { useRoleTheme } from "../../hooks/useRoleTheme";
interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: BoxIcon;
  /** 'warm' uses the brand's secondary icon accent (e.g. spotlight sparkle) */
  iconTone?: 'default' | 'warm';
  action?: {
    label: string;
    to: string;
  };
  className?: string;
}

/**
 * SectionHeader — title row for a page section, with an optional icon,
 * supporting line, and "View all" link. Colours come from the brand theme.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  iconTone = 'default',
  action,
  className = 'mb-6'
}) => {
  const {
    theme
  } = useBrand();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const iconColor = iconTone === 'warm' ? theme.accent.iconWarm : theme.accent.icon;
  const heading = <h2 className={`text-2xl font-bold flex items-center ${dk.textHeading}`} data-id="element-3416" data-mp="3kqh6e54u75ct">
      {Icon && <Icon className={`h-6 w-6 mr-2 ${iconColor}`} data-id="element-3417" data-mp="3ko4eaz5d7em1" />}
      {title}
    </h2>;
  return <div className={`flex items-center justify-between gap-4 ${className}`} data-id="element-3418" data-mp="35v14xf1xg76e">
      {subtitle ? <div data-id="element-3419" data-mp="3ast66zogp5n9">
          {heading}
          <p className={dk.textSecondary} data-id="element-3420" data-mp="2chln2188bnq">{subtitle}</p>
        </div> : heading}
      {action && <Link to={action.to} className={`font-medium flex items-center whitespace-nowrap ${rt.accentLink}`} data-id="element-3421" data-mp="2eu3zgawco1b">
          {action.label}
          <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-3422" data-mp="3osu9smw42r6f" />
        </Link>}
    </div>;
};
export default SectionHeader;